var phoneCode = require('./components/phone-mask/phone-codes.js');

$(function () {
    var maskList = $.masksSort(phoneCode, ["#"], /[0-9]|#/, "mask");

    function maskTel(el) {
        var maskOpts = {
            inputmask: {
                definitions: {
                    '#': {validator: "[0-9]", cardinality: 1}
                },
                clearIncomplete: true,
                showMaskOnHover: false,
                // autoUnmask: true
            },
            match: /[0-9]/,
            replace: '#',
            list: maskList,
            listKey: "mask",
        }
        $(el).inputmasks(maskOpts);
    }

    maskTel('input[type="tel"]');

    $('input[type="tel"]').on('paste', function (e) {
        if (!$(this).hasClass('focus.inputmask')) {
            e.preventDefault();
        }
    });

    $('.custom-select__js').each(function () {
        $(this).custom_select();
    });

    $('.checkbox-list__js').each(function () {
        $(this).checkbox_list();
    });

    $('.toggle').on('click', function () {
        $(this).toggleClass('toggle_on')
    });

    $(document).on('click', '.btn_more_action', function () {
        var _this = $(this);
        var pathname = window.location.pathname;
        var hostname = window.location.protocol + '//' + window.location.hostname;

        // Открывает страницу поиска по кнопке, если пользователь на главной странице
        if (pathname === '/') {
            window.open(hostname + '/apartments', 'search').focus();
            return;
        }

        $.ajax({
            url: _this.data('url'),
            success: function (json) {
                _this.replaceWith(json['html']);
                fast_background.update(function () {
                    $(document).trigger('initSlider');
                });
            }
        })
    });

    $('.complex-dot').on('click', function () {
        if ($(window).width() <= 768) {
            if ($(this).data('image')) {
                $('#modal-render').find('.card-body__image-img').attr('src', $(this).data('image')).show();
            } else {
                $('#modal-render').find('.card-body__image-img').hide();
            }
            $('#modal-render').find('.card__title').text($(this).data('title'));
            $('#modal-render').find('.card__subtitle').html($(this).data('description'));
            $('#modal-render').find('.lots-count').text($(this).data('lots-count'));
            $('#modal-render').find('a').attr('href', $(this).data('url'));
            $('#modal-render').find('.lots-count').attr('href', $(this).data('lots-url'));
            if (!$(this).data('has-lots')) {
                $('#modal-render').find('.card__line-item--price-area, .card__line-item--lots-count').hide();
            } else {
                $('#modal-render').find('.card__line-item--price-area, .card__line-item--lots-count').show();
                $('#modal-render').find('.min-price-gbp').text($(this).data('min-price-gbp'));
                $('#modal-render').find('.min-price-aed').text($(this).data('min-price-aed'));
                $('#modal-render').find('.min-price-usd').text($(this).data('min-price-usd'));
                $('#modal-render').find('.min-area').text($(this).data('min-area'));
            }
            $('#modal-render').show();
            $('#modal-render').find('.card_development_render').addClass('card_development_render_modal');
            return;
        }
        var cardId = 'render-card-' + $(this).data('dot-id'),
            renderCard;

        $('.card_development_render').removeClass('show').css('opacity', 0);
        if (!$('#' + cardId).length) {
            renderCard = $('#complex-render-card').clone();

            renderCard.attr('id', cardId);

            if ($(this).data('image')) {
                renderCard.find('.card-body__image-img').attr('src', $(this).data('image')).show();
            } else {
                renderCard.find('.card-body__image-img').hide();
            }

            renderCard.find('.card__title').text($(this).data('title'));
            renderCard.find('.card__subtitle').html($(this).data('description'));
            renderCard.find('.lots-count').text($(this).data('lots-count'));
            renderCard.find('a').attr('href', $(this).data('url'));
            renderCard.find('.lots-count').attr('href', $(this).data('lots-url'));

            if (!$(this).data('has-lots')) {
                renderCard.find('.card__line-item--price-area, .card__line-item--lots-count').hide();
            } else {
                renderCard.find('.card__line-item--price-area, .card__line-item--lots-count').show();
                renderCard.find('.min-price-gbp').text($(this).data('min-price-gbp'));
                renderCard.find('.min-price-aed').text($(this).data('min-price-aed'));
                renderCard.find('.min-price-usd').text($(this).data('min-price-usd'));
                renderCard.find('.min-area').text($(this).data('min-area'));
            }


            $(this).after(renderCard);
            renderCard.addClass('show');

            var left = parseFloat($(this).css('left')) + $(this).width() + 20,
                top = parseFloat($(this).css('top')) - ($(renderCard).height() / 2) + ($(this).height() / 2) - parseFloat($(renderCard).css('padding-top'));

            renderCard.css({
                left: left,
                top: top
            });

            if (renderCard.offset().left + renderCard.width() > $(window).width()) {
                renderCard.addClass('left');
                left = parseFloat($(this).css('left')) - $(this).width() - 20 - renderCard.width();

                renderCard.css({
                    left: left
                });
            }
        } else {
            renderCard = $('#' + cardId);
        }

        renderCard.addClass('show');
        renderCard.animate({opacity: 1});

        $(this).mouseleave(function () {
            $(document).click(function (event) {
                if (!event.target.closest('.card_development_render')) {
                    renderCard.remove();
                }
            });
        });

    });
});


$(function () {
	var utmNames = ['utm_source', 'utm_medium', 'utm_content', 'utm_term', 'utm_campaign'],
	utm = '';

	var paramsString = document.location.search,
		searchParams = new URLSearchParams(paramsString);

	for (var i = 0; i < utmNames.length; i++) {
		var utmValue = searchParams.get(utmNames[i]);
		if (utmValue) {
			utm += `&${utmNames[i]}=` + utmValue;
			$.cookie(utmNames[i], utmValue);
		}
	}
	$.cookie('utm', utm);
});


$(function () {
    function reportError(data, form_name, crm_http_code) {
        window.formErrorApi(data, form_name, crm_http_code);
        alert(whitewillConfig.translates.ajax_oops);
    }

    $(document).on('click', '[data-form]', function (event) {
        var this_el = $(this); //DOM элемент который инициировал событие
        var method = this_el.data('method')

        var isNewWindow = this_el.data('new-window')
        var form = this_el.parents('.form'); //Родительская (текущая) форма/
        var form_name = form.data('testid');
        var data = {};
        form.find('input').each(function () {
            data[$(this).attr('name')] = $(this).val();
        })


		if($.cookie('_ym_uid'))
			data['_ym_uid'] = $.cookie('_ym_uid');
		if (typeof (Ya) != 'undefined')
			data['yandex_metrika_id'] = Ya.Metrika2.counters()[0].id;
		if($.cookie('utm_campaign'))
			data['utm_campaign'] = $.cookie('utm_campaign');
		if($.cookie('utm_term'))
			data['utm_term'] = $.cookie('utm_term');
		if($.cookie('utm_content'))
			data['utm_content'] = $.cookie('utm_content');
		if($.cookie('utm_medium'))
			data['utm_medium'] = $.cookie('utm_medium');
		if($.cookie('utm_source'))
			data['utm_source'] = $.cookie('utm_source');


        var url = new URL($(this).attr('data-form'));
        url.search = window.location.search;

        $.ajax({
            url: url.toString(),
            method: 'post',
            dataType: 'json',
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            complete: function (jqXHR) {
                if (jqXHR.status === 422) { //Обработка ошибок валидации для Laravel
                    var errors = jqXHR.responseJSON.errors;
                    for (var key in errors) {
                        if (!errors.hasOwnProperty(key)) continue;
                        var field = form.find('[name="' + key + '"]');
                        if (field.length && field.attr('type') !== 'hidden') {
                            field.addClass('has-error');// Помечаем поле не прошедшее валидацию
                            field.siblings('.error').html(errors[key][0]); //Выводим сообщение об ошибке валидации
                        } else {
                            reportError(data, form_name, 0); //Если поле не найдено или имеет type hidden, то оповещаем об ошибке в чате
                            break;
                        }
                    }
                } else {
                    if (!jqXHR.responseJSON || jqXHR.responseJSON.status !== 'form_sent_ok') { //При успешной отправке формы сервер должен отвечать: echo json_encode({"status":"form_sent_ok"}); Кроме status можно добавить другие данные
                        reportError(data, form_name, jqXHR.responseJSON.crm_http_code); //Если ответ другой, то оповещаем об ошибке в чате
                        return false;
                    }
                    window.g_send_goal(this_el.data('goal'), this_el.data('goal-category'));

                    if (jqXHR.responseJSON.redirect !== undefined) {
                        window.location.href = jqXHR.responseJSON.redirect;
                    } else {
                        alert(whitewillConfig.translates.ajax_success)
                    }
                }
            }
        });
    });
});

$(document).ready(function () {

    $(document).on('click', '.complex-faq__item', function (){
        var faqItem = $(this).closest('.complex-faq__item');

        if ($(faqItem).hasClass('active')) {
            faqItem.removeClass('active');
            faqItem.find('.complex-faq__answer').slideUp(300);
            return false;
        }

        faqItem.toggleClass('active');
        faqItem.find('.complex-faq__answer').slideToggle(300);
    })

    var $modalExpert = $('#popup_expert');
    var unread = true;
    let popupExpert = $('.popup_expert__image');

    if ($(window).width() > 767) {
        $modalExpert.addClass('active').addClass('dt');
        fast_background.update();
    }

    $(window).on('resize', function () {
        if (!$modalExpert.hasClass('scroll-ignore')) {
            if ($(window).width() <= 767 && $modalExpert.hasClass('dt')) {
                $modalExpert.removeClass('active').removeClass('dt');
            }
            if ($(window).width() > 767 && !$modalExpert.hasClass('dt')) {
                $modalExpert.addClass('active').addClass('dt');
                fast_background.update();
            }
        }
    });

    $('.popup_expert__close').click(function () {
        $modalExpert.removeClass('active').addClass('no-activate').removeClass('scroll-ignore')
    });

    $(window).on('scroll.popup_expert', function () {
        if (!$modalExpert.hasClass('scroll-ignore')) {
            if ($(window).scrollTop() > $(window).height() * 1.5) {
                if ($(window).width() > 767) {
                    $(window).off('scroll.popup_expert');
                    popupExpert.click()
                }
                $modalExpert.css('display', '')
            } else {
                $modalExpert.removeClass('active')
            }
        }
    });

    popupExpert.on('click', function () {
        unread = false;
        $modalExpert.removeClass('no-activate').addClass('scroll-ignore').removeClass('unread');
        if (!$modalExpert.hasClass('active')) {
            popupExpert.animate({
                width: 0,
                height: 0,
                marginTop: -47,
                marginRight: 40
            }, 300, function () {
                popupExpert.attr('style', '');
                $modalExpert.addClass('active')
            })
        }
    });

    setTimeout(function () {
        if (unread) {
            if ($modalExpert.hasClass('active')) {
                $modalExpert.addClass('no-activate').removeClass('active');
            }
            $modalExpert.addClass('unread').css('display', '');
            fast_background.update();
        }
    }, 10000)

    // аккордион в подвале
    $('.link-group__title_accordion').on('click', function (event) {
        if ($(window).width() > 768) return;
        event.preventDefault();
        $(this).toggleClass('active');
        $(this).siblings('.link-group__list').slideToggle();
    });

    // Мобильная версия рендера на главной странице
    function renderScrollAnimate() {
        if ($('.main-image').length == 0 || $(window).width() > 768) return;
        var PerfectScrollbar = require('perfect-scrollbar/dist/perfect-scrollbar.common');
        var renderImage = $('.main-image');
        var ps = new PerfectScrollbar('.main-image');
        renderTop = renderImage.offset().top - (renderImage.height() / 2);
        $(window).scroll(function () {
            if (!renderImage.hasClass('scroll') && $(document).scrollTop() >= renderTop) {
                renderImage.addClass('scroll');
                renderImage.animate({
                    scrollLeft: 50
                }, 600, 'swing', (function () {
                    renderImage.animate({
                        scrollLeft: 0
                    }, 200, 'linear')
                }));
            }
        });
    }

    renderScrollAnimate();

    // COOKIE
    if (!whitewillConfig.showedCookieBar) {
        $('#cookie_confirm').fadeIn();
    }
    $('.cookie_confirm__button').on('click', function () {
        document.cookie = "showedCookieBar=1";
        $('#cookie_confirm').fadeOut();
    });

});

$(document).on('click', '[data-href]', function (e) {
    window.open($(this).data('href'));
});
$(document).on('click', '[data-href] a', function (e) {
    e.stopPropagation();
});

/**
 *Отправка целей в Яндекс.Метрика и Google Analytics
 * */
window.g_send_goal = function (goal, category = null) {
    try {
        console.log('g_send_goal ' + goal + ' ' + category);
        if (typeof (ym) != "undefined") {
            ym(Ya.Metrika2.counters()[0].id, 'reachGoal', goal, null, function () {
                console.log('ym ok');
            });
        }
        if (typeof (gtag) != "undefined") {
            gtag('event', goal, {
                'event_category': category,
                'event_callback': function () {
                    console.log('gtag ok');
                }
            });
        }
    } catch (e) {
        console.error(e.message);
    }
}

//Выбор языка
$('.header__language-item').click(function () {
    $(this).toggleClass('active');
    $(this).children('.header__language-dropdown').fadeToggle();
});

$(document).mouseup(function (e) {
    var $el = $('.header__language-item');
    if ($el.length && $el.hasClass('active')) {
        if (!$el.is(e.target) && $el.has(e.target).length === 0) {
            $el.removeClass('active');
            $el.children('.header__language-dropdown').fadeOut();
        }
    }
});

// Faq
$('.faq__question').click(function () {
    var faqItem = $(this).closest('.faq__item');

    if ($(faqItem).hasClass('active')) {
        faqItem.removeClass('active');
        faqItem.find('.faq__answer').slideUp(300);
        return false;
    }

    $('.faq__item').each(function (i, el) {
        $(el).removeClass('active')
        $(el).find('.faq__answer').slideUp(300);
    });

    faqItem.toggleClass('active');
    faqItem.find('.faq__answer').slideToggle(300);
});


// Rate
$(document).ready(function () {
    $('.star-rating-add').click(function () {
        var SR_wrapper = $('[data-star-rating]');
        var route = SR_wrapper.data('route');
        var label = $(this);
        var input = $('#' + label.attr('for'));
        var ajaxData = {
            'model_id': SR_wrapper.data('model-id'),
            'model_class': SR_wrapper.data('model-class'),
            'rate': input.val(),
        }
        $.ajax({
            url: route,
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': $('[name="csrf-token"]').attr('content')
            },
            data: ajaxData,
            beforeSend: function (ajaxData) {
            },
            success: function (json) {
            },
            error: function () {
                alert('Кажется, что-то пошло не так...')
            }
        })
    })
})

// annotation
$(document).ready(function () {
    $('.annotation__point').click(function () {
        var isActive = 0;
        var wrapper = $(this).closest('.annotation__pointWrapper');
        var childrens = wrapper.find('.annotation__subPoint');
        if(childrens.hasClass('active')){
            isActive = 1;
        }
        var allItems = $('.annotation__subPoint');
        allItems.removeClass('active');
        if(!isActive){
            childrens.addClass('active');
        }

    });
})

$(document).ready(function() {
    var page404 = $('[data-send-error-ym]');
    if ( page404.length && typeof window.ym != 'undefined' ) {
        var interval = setInterval(function() {
            if (typeof Ya !== 'undefined') {
                yaId = Ya.Metrika2.counters()[0].id;
                var ref = document.referrer;
                var url = document.location.href;
                var params404 = {'404 ошибка': {'URL-адрес': url, 'Реферер': ref}};
                ym(yaId, 'reachGoal', '404error', params404);
                console.log('Цель 404error отправлена' + yaId);
                clearInterval(interval);
            }
        }, 300);
    }

    /**
     * Показать скрытые пункты меню в футере
     */
    $(document).on('click', '.btn-toggle', function() {
        const $showBtn = $(this).children('.btn-show')
        const $hideBtn = $(this).children('.btn-hide')
        if (!$showBtn || !$hideBtn) return

        const $toggleableContainer = $(this).parent('.toggleable-container')
        const $toggleableBlock = $toggleableContainer.find('.toggleable-block')
        if (!$toggleableContainer || !$toggleableBlock) return

        if ($toggleableBlock.css('display') === 'none') {
            $toggleableBlock.fadeIn()
            $showBtn.hide()
            $hideBtn.show()
        }
        else {
            $toggleableBlock.fadeOut()
            $showBtn.show()
            $hideBtn.hide()
        }
    })
})

